import React, { useState } from 'react';
import { Lock, X, Eye, EyeOff, Loader2, Info } from 'lucide-react';
import { changePassword } from '../../services/analysisService';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Modale cambio password.
 * @param {Object} props
 * @param {Function} props.onClose - chiude il modale
 */
export const ChangePasswordModal = ({ onClose }) => {
  const { isAdmin } = useAuth();
  const [form, setForm] = useState({ current: '', newPw: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [visible, setVisible] = useState({ current: false, newPw: false, confirm: false });

  const handleSubmit = async () => {
    if (form.newPw !== form.confirm) {
      setMsg({ type: 'error', text: 'Le password non coincidono' });
      return;
    }
    if (form.newPw.length < 6) {
      setMsg({ type: 'error', text: 'La nuova password deve avere almeno 6 caratteri' });
      return;
    }
    setLoading(true);
    setMsg({ type: '', text: '' });
    try {
      await changePassword(form.current, form.newPw);
      setMsg({ type: 'success', text: 'Password aggiornata con successo!' });
      setForm({ current: '', newPw: '', confirm: '' });
      setTimeout(onClose, 1500);
    } catch (e) {
      const detail = e.response?.data?.detail;
      setMsg({ type: 'error', text: typeof detail === 'string' ? detail : 'Errore nel cambio password' });
    }
    setLoading(false);
  };

  const renderField = (label, key, testId) => (
    <div>
      <label className="block text-xs font-medium text-[#5C6E5C] uppercase tracking-wider mb-1">{label}</label>
      <div className="relative">
        <input
          type={visible[key] ? 'text' : 'password'}
          value={form[key]}
          onChange={(e) => setForm((p) => ({ ...p, [key]: e.target.value }))}
          className="el-input w-full pr-10"
          data-testid={testId}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => ({ ...v, [key]: !v[key] }))}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5C6E5C] hover:text-[#1B291B]"
        >
          {visible[key] ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6" onClick={(e) => e.stopPropagation()} data-testid="change-password-modal">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-medium text-[#1B291B]">Cambia Password</h2>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-[#F4F7F4]" data-testid="close-password-modal">
            <X className="w-5 h-5 text-[#5C6E5C]" />
          </button>
        </div>
        {msg.text && (
          <div className={`mb-4 p-3 rounded-xl text-sm ${msg.type === 'error' ? 'bg-red-50 text-red-600 border border-red-200' : 'bg-green-50 text-green-600 border border-green-200'}`}>
            {msg.text}
          </div>
        )}
        <div className="space-y-4">
          {isAdmin && (
            <div className="p-3 rounded-xl text-xs bg-amber-50 text-amber-700 border border-amber-200 flex items-start gap-2" data-testid="admin-password-note">
              <Info className="w-4 h-4 shrink-0 mt-0.5" />
              <span>La password dell'account amministratore è gestita centralmente: in caso di riavvio o nuova pubblicazione del sistema potrebbe essere ripristinata al valore configurato. Per un cambio permanente contatta la gestione del deployment.</span>
            </div>
          )}
          {renderField('Password attuale', 'current', 'current-password-input')}
          {renderField('Nuova password', 'newPw', 'new-password-input')}
          {renderField('Conferma nuova password', 'confirm', 'confirm-password-input')}
          <button
            onClick={handleSubmit}
            disabled={loading || !form.current || !form.newPw || !form.confirm}
            className="el-btn-primary w-full flex items-center justify-center gap-2 py-3"
            data-testid="submit-password-change"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            Aggiorna Password
          </button>
        </div>
      </div>
    </div>
  );
};
